import React, { Component } from 'react';
import Icon from 'components/common/Icon';
import isObject from 'lodash/isObject';

export default class ScheduleList extends Component {

  render() {
    const { schedule, onSelect, drawDivider, showChevron } = this.props;

    if (!schedule || !schedule.id) {
      return <div></div>;
    }

    let description;

    let displayClass = 'data';

    if (schedule.description && schedule.description.length) {
      description = (
        <div className="subtext">
          <span key="schedule-description" dangerouslySetInnerHTML={{ __html: schedule.description }} />);
        </div>
      );
    }

    /* eslint react/jsx-no-bind: 0 */
    const renderItem = () => (
      <div className="list-item clickable" onClick={onSelect.bind(null, schedule)}>
        <div className="inner">
          <div className={displayClass}>
            {schedule.name}
            {description}
          </div>
        </div>

        {showChevron && (
          <Icon icon="arrow" className="link-indicator" />
        )}

        {drawDivider && (
          <div className="divider"></div>
        )}
      </div>
    );

    return (
      <span>
        {renderItem()}
      </span>
    );
  }
}

/* eslint no-console: ["error", { allow: ["info"] }] */
ScheduleList.defaultProps = {
  onSelect: (schedule) => console.info('Schedule selected', schedule.name),
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/ScheduleListItem.js